// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.LifelineEventAddModal_overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.LifelineEventAddModal_content {
    background: white;
    border-radius: 12px;
    padding: 24px;
    min-width: 400px;
    max-width: 500px;
    width: 90%;
    box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.2);
}

.LifelineEventAddModal_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.LifelineEventAddModal_header h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #333;
}

.LifelineEventAddModal_close {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #999;
    padding: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.LifelineEventAddModal_close:hover {
    color: #666;
}

.LifelineEventAddModal_form {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;
}

.LifelineEventAddModal_field {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.LifelineEventAddModal_field label {
    font-size: 14px;
    font-weight: 500;
    color: #333;
}

.LifelineEventAddModal_field input,
.LifelineEventAddModal_field textarea,
.LifelineEventAddModal_field select {
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.2s;
}

.LifelineEventAddModal_field input:focus,
.LifelineEventAddModal_field textarea:focus,
.LifelineEventAddModal_field select:focus {
    border-color: #14AE5C;
}

.LifelineEventAddModal_field textarea {
    resize: vertical;
    min-height: 60px;
    font-family: inherit;
}

.LifelineEventAddModal_radio_group {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.LifelineEventAddModal_radio_label {
    display: flex !important;
    flex-direction: row !important;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-weight: normal !important;
}

.LifelineEventAddModal_radio_label input[type="radio"],
.LifelineEventAddModal_checkbox_label input[type="checkbox"] {
    width: auto;
    margin: 0;
}

.LifelineEventAddModal_checkbox_label {
    display: flex !important;
    flex-direction: row !important;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-weight: normal !important;
}

.LifelineEventAddModal_actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
}

.LifelineEventAddModal_cancel {
    background-color: #f5f5f5;
    color: #666;
    border: none;
    padding: 8px 16px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: background-color 0.2s;
}

.LifelineEventAddModal_cancel:hover:not(:disabled) {
    background-color: #eee;
}

.LifelineEventAddModal_save {
    background-color: #14AE5C;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: background-color 0.2s;
}

.LifelineEventAddModal_save:hover:not(:disabled) {
    background-color: #0f8a47;
}

.LifelineEventAddModal_cancel:disabled,
.LifelineEventAddModal_save:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/lifeline/LifelineEventAddModal.css"],"names":[],"mappings":";AACA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;IACX,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;;;IAGI,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,6BAA6B;AACjC;;AAEA;;;IAGI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,8BAA8B;AAClC;;AAEA;;IAEI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":["\n.LifelineEventAddModal_overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.LifelineEventAddModal_content {\n    background: white;\n    border-radius: 12px;\n    padding: 24px;\n    min-width: 400px;\n    max-width: 500px;\n    width: 90%;\n    box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.2);\n}\n\n.LifelineEventAddModal_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.LifelineEventAddModal_header h3 {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 600;\n    color: #333;\n}\n\n.LifelineEventAddModal_close {\n    background: none;\n    border: none;\n    font-size: 24px;\n    cursor: pointer;\n    color: #999;\n    padding: 0;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.LifelineEventAddModal_close:hover {\n    color: #666;\n}\n\n.LifelineEventAddModal_form {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    margin-bottom: 24px;\n}\n\n.LifelineEventAddModal_field {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.LifelineEventAddModal_field label {\n    font-size: 14px;\n    font-weight: 500;\n    color: #333;\n}\n\n.LifelineEventAddModal_field input,\n.LifelineEventAddModal_field textarea,\n.LifelineEventAddModal_field select {\n    padding: 8px 12px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    font-size: 14px;\n    outline: none;\n    transition: border-color 0.2s;\n}\n\n.LifelineEventAddModal_field input:focus,\n.LifelineEventAddModal_field textarea:focus,\n.LifelineEventAddModal_field select:focus {\n    border-color: #14AE5C;\n}\n\n.LifelineEventAddModal_field textarea {\n    resize: vertical;\n    min-height: 60px;\n    font-family: inherit;\n}\n\n.LifelineEventAddModal_radio_group {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.LifelineEventAddModal_radio_label {\n    display: flex !important;\n    flex-direction: row !important;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    font-weight: normal !important;\n}\n\n.LifelineEventAddModal_radio_label input[type=\"radio\"],\n.LifelineEventAddModal_checkbox_label input[type=\"checkbox\"] {\n    width: auto;\n    margin: 0;\n}\n\n.LifelineEventAddModal_checkbox_label {\n    display: flex !important;\n    flex-direction: row !important;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    font-weight: normal !important;\n}\n\n.LifelineEventAddModal_actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n}\n\n.LifelineEventAddModal_cancel {\n    background-color: #f5f5f5;\n    color: #666;\n    border: none;\n    padding: 8px 16px;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: background-color 0.2s;\n}\n\n.LifelineEventAddModal_cancel:hover:not(:disabled) {\n    background-color: #eee;\n}\n\n.LifelineEventAddModal_save {\n    background-color: #14AE5C;\n    color: white;\n    border: none;\n    padding: 8px 16px;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: background-color 0.2s;\n}\n\n.LifelineEventAddModal_save:hover:not(:disabled) {\n    background-color: #0f8a47;\n}\n\n.LifelineEventAddModal_cancel:disabled,\n.LifelineEventAddModal_save:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
